var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'normal',attrs:{"id":"snake"}},[_c(_vm.started,{tag:"component",attrs:{"gameToggle":_vm.toggler}},[_c('h1',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Snake")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }